// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__2an36","footerContainer":"Footer_footerContainer__FrhbV","textLock":"Footer_textLock__U-fsh","wifiLogo":"Footer_wifiLogo__YrrDD"};